import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js"
import React from 'react'
import { LoadingComponent } from "../../components/LoadingComponent";
import { Button } from "@mui/material";
import { saveCardToken } from "../../Services/Events.services";
import swal from "sweetalert";

const CARD_OPTIONS = {
	style: {
		base: {
			iconColor: "#c4f0ff",
			color: "#000",
			fontWeight: 700,
			fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
			fontSize: "16px",
			fontSmoothing: "antialiased",
		},
		invalid: {
			iconColor: "red",
			color: "red"
		},
	},
    iconStyle: "solid",
    hidePostalCode: true,
}

export default function PaymentForm() {

    const [spinnerList, setSpinnerList] = React.useState(false);
    const stripe = useStripe()
    const elements = useElements()


    const handleSubmit = async (e) => {
        try {
            const card = elements.getElement(CardElement);
            const result = await stripe.createToken(card);
            if (!result.error) {
                setSpinnerList(true);
                const response = await saveCardToken({
                    stripeToken: result.token.id,
                    flag: 'p1c0s1',
                    cardNumber: result.token.card.id,
                });
                if (response.status === 201) {
                    setSpinnerList(false);
                    window.location.reload();
                }
            } else {
                setSpinnerList(false);
                swal('Error', result.error, 'error');
            }
            setSpinnerList(false);
        } catch (err) {
            setSpinnerList(false)
            swal('Error', err.response.data.message, 'error');
        }
    }

    return (
        <>
        {
            <LoadingComponent loader={spinnerList}>
                <fieldset className="FormGroup">
                    <div className="FormRow">
                        <CardElement options={CARD_OPTIONS}/>
                    </div>
                </fieldset>
                <Button variant="outlined"
                    style={{ backgroundColor: 'transparent', borderRadius: '10px', left: '33%', top: '10px', lineHeight: '1', width: "100px", height: "50px",
                    fontFamily: "Work Sans", fontWeight: "800", fontStyle: "italic", fontSize: "20px",
                    textTransform: "none", border: "3px solid #538103", color: '#538103' }}
                    disableRipple={true}
                    onClick={handleSubmit}
                    >
                        save
                </Button>
            </LoadingComponent>
        }      
        </>
    )
}